import type { ComponentProps } from 'react'
import { cn, tv } from '@joyful/utils'
import type { VariantProps } from '@joyful/utils'

export const pageMainVariants = tv({
  base: 'w-full',

  defaultVariants: {
    background: 'none',
    grow: 'auto',
    padding: 'page',
    position: 'static',
  },

  variants: {
    background: {
      muted: 'bg-tremor-background-muted',
      none: null,
      warm: 'bg-tremor-background-warm',
    },

    grow: {
      auto: null,
      fill: 'flex flex-1 flex-col',
    },

    padding: {
      compact: 'py-4 px-2 sm:px-6 lg:px-8',
      horizontal: 'px-2 sm:px-6 lg:px-8',
      none: null,
      page: 'py-6 md:py-8 px-2 sm:px-6 lg:px-8',
      vertical: 'py-6 md:py-8',
    },

    position: {
      relative: 'relative',
      static: null,
    },
  },
})

export type PageMainProps = ComponentProps<'main'> &
  VariantProps<typeof pageMainVariants>

export function PageMain({
  background,
  children,
  className,
  grow,
  padding,
  position,
  ref,
  ...props
}: PageMainProps) {
  return (
    <main
      ref={ref}
      className={cn(
        pageMainVariants({
          background,
          grow,
          padding,
          position,
        }),
        className,
      )}
      {...props}
    >
      {children}
    </main>
  )
}
